import { storage as StorageI18n } from "./storage";
import { storageAdd } from "./storage-add";
import { storageList } from "./storage-list";
import { storageTransfer } from "./storage-transfer";
import { storageHistory } from "./storage-history";
import { storageAlerts } from "./storage-alerts";
import { nfReport } from "./nf-report";
import { profitMarginReport } from "./profit-margin-report";
import { cmvCost } from "./cmv-cost";
import { cmvReport } from "./cmv-report";
import { lossReport } from "./loss-report";
import { purchaseInvoice } from "./purchase-invoice";
import { inventoryControl } from "./inventory-control";
import { storages } from "./storages";
import { abcReports } from "./abc-reports";
import { irregularCmvProducts } from "./irregular-cmv-products";
import { stockPositionReport } from "./stock-position-report";
import { productionControl } from "./production-control";
import { manualInvoiceImporting } from "./manual-invoice-importing";
import { storageListV2 } from "./storage-list-v2";
import { storageV2 } from "./storage-v2";

export const storage = {
	storage: StorageI18n,
	storageAdd,
	storageList,
	storageListV2,
	storageTransfer,
	tabs: {
		storages,
		storageHistory,
		storageAlerts,
		profitMarginReport,
		nfReport,
		purchaseInvoice,
		cmvCost,
		cmvReport,
		lossReport,
		inventoryControl,
		abcReports,
		irregularCmvProducts,
		stockPositionReport,
		productionControl,
		manualInvoiceImporting,
		storageV2,
	},
};
